/*
 * jBone.widget.paging
 */

define(function(require, exports, module) {
    'use strict';
    var $ = require('j');
    var core = require('core');
    var tmpl = require('tmpl');
    var mathAlgorithms = require('util/math.util').algorithms;
    var Swipe = require('class/swipe.class');
    require('common/jbone.widget');

    module.exports = $.widget('paging', {

        /**
         * Options by default
         * @type {Object}
         */
        options: {

            /**
             * Current page
             * @type {Number}
             */
            activePage: 0,

            /**
             * Previous page
             * @type {Number}
             */
            beforePage: 0,

            /**
             * Type of buttons ('bullet' || 'number')
             * @type {String | Boolean}
             */
            type: false,

            /**
             * Previous and Next buttons
             * @type {Boolean}
             */
            arrows: false,

            /**
             * Arrows vertical position (default is 50%)
             * @type {Number}
             */
            arrowPosition: null,

            /**
             * Position unit for margin of arrows ('percent' || 'pixels')
             * @type {String}
             */
            arrowPositionUnit: 'percent',

            /**
             * Bullets X position ('left' || 'center' || 'right')
             * @type {String}
             */
            bulletsPositionX: 'center',

            /**
             * Bullets Y position ('top' || 'bottom')
             * @type {String}
             */
            bulletsPositionY: 'bottom',

            /**
             * Bullets X offset from specified position
             * @type {Number}
             */
            bulletsOffsetX: 0,

            /**
             * Bullets Y offset from specified position
             * @type {Number}
             */
            bulletsOffsetY: 0,

            /**
             * Infinity banner rotation option
             *
             * If you go to the front slide from last slide first slide should be presented
             * And some case for first slide
             *
             * @type {boolean}
             */
            infinity: true,

            /**
             * Time for slide animation
             * @type {Number}
             */
            animationTime: 500,

            /**
             * Animation function for sliding, see in math.util.algorithms.*
             * @type {Function}
             */
            slideAnimationFunction: mathAlgorithms.easeOutQuint,

            /**
             * Type of animation ('monoSlider' || 'fading')
             * @type {String}
             */
            animationType: 'monoSlider'
        },

        /**
         * $el.paging() widget
         * @param  {Object} options See default options
         */
        init: function(options) {
            this.$pages = this.$el.find('.fn-paging-pages');
            this.isSliderType = this.options.animationType === 'monoSlider';
            this.options.lengthOfPages = options && options.lengthOfPages || this.$pages[0].children.length;
            this.options.swipe = this.pageSlider = new Swipe(this.$pages);
            this._handleArrowPositionUnit();

            if (this.options.lengthOfPages > 0) {
                this.render();
            }

            if (this.options.infinity && this.isSliderType) {
                this._addClones();
            }
        },

        render: function() {
            this.$pagingItems = this.$pages.find('.paging__item');
            this.$el.addClass('paging');

            if (this.$pagingItems && this.$pagingItems.length > 1) {
                this.$pages.parent().append(tmpl['paging.widget.pager'](this.options));
                this.$paging = this.$el.find('.fn-paging-list');
                this.$bullets = this.$paging.find('.fn-bullet');

                this.on(this.$el, {
                    'tap .fn-bullet': this._gotoPage,
                    'tap .fn-goto-previous': this.gotoPrevious,
                    'tap .fn-goto-next': this.gotoNext
                }, this);

                if (this.options.type) {
                    this._setPagerPosition();
                    this._setActivePager(this.options.activePage);
                }

                if (this.isSliderType) {
                    this.pageSlider.translate(this.options.activePage * -100, 0, '%');
                }

                this._bindTouch();
            }

            if (this.options.animationType === 'fading') {
                this.$pagingItems[0].classList.add('fadeIn');
            }

            return this;
        },

        _gotoPage: function(e) {
            e.stopPropagation();

            this.gotoPage(Number(e.target.dataset.page), null, null, e);
        },

        /**
         * Go to previous page
         */
        gotoPrevious: function(e) {
            var expected = this.options.activePage;

            if (expected > 0) {
                expected -= 1;
            } else if (this.options.infinity) {
                expected = this.options.lengthOfPages - 1;
            }

            this.gotoPage(expected, null, null, e);

            if (e && e.stopPropagation) {
                e.stopPropagation();
            }
        },

        /**
         * Go to next page
         */
        gotoNext: function(e) {
            var expected = this.options.activePage;

            if (expected < this.options.lengthOfPages - 1) {
                expected += 1;
            } else if (this.options.infinity) {
                expected = 0;
            }

            this.gotoPage(expected, null, null, e);

            if (e && e.stopPropagation) {
                e.stopPropagation();
            }
        },

        _setPagerPosition: function() {
            var big = this.options.type === 'number' ? ' paging__pages_type_number' : '';

            this.$pages.addClass('paging__pages_position_' + this.options.bulletsPositionY + big);
        },

        _addClones: function() {
            var $pages = this.$el.find('.fn-paging-item');
            var slideWrapper = document.createDocumentFragment();
            var firstTwoSlides = $pages.filter(function(page, i) { return i < 2; });
            var lastTwoSlides = $pages.filter(function(page, i) { return i >= $pages.length - 2; });

            function cloneSlide(slide) {
                var cloned = slide.cloneNode(true);

                cloned.classList.add('cloned');
                cloned.classList.remove('active');

                return cloned;
            }

            lastTwoSlides
                .map(cloneSlide)
                .forEach(slideWrapper.appendChild, slideWrapper);

            $pages.forEach(slideWrapper.appendChild, slideWrapper);

            firstTwoSlides
                .map(cloneSlide)
                .forEach(slideWrapper.appendChild, slideWrapper);

            this.options.swipe.translate((this.options.activePage + 2) * -100, 0, '%');
            this.$pages.append(slideWrapper);
        },

        _bindTouch: function() {
            this.pageSlider.on({
                move: function(item) {
                    if (!this.isSliderType) {
                        return;
                    }

                    var isFirstPage = this.options.activePage === 0 && item.delta.x < 0;
                    var isLastPage = this.options.activePage === this.options.lengthOfPages - 1 && item.delta.x > 0;
                    var ratio = 1;

                    if (!this.options.infinity && (isFirstPage || isLastPage)) {
                        ratio = 0.33;
                    }

                    item.translate(item.start.x - item.delta.x / (window.innerWidth / 100) * ratio, 0, '%');
                },

                end: function(item) {
                    if (item.direction.x > 0) {
                        this.gotoNext();
                    } else if (item.direction.x < 0) {
                        this.gotoPrevious();
                    } else {
                        this.gotoPage(this.options.activePage);
                    }
                }
            }, this);
        },

        /**
         * Go to page
         * @param  {Number}     index
         * @param  {String}     typeAnimation
         * @param  {Function}   callback
         * @param  {Event}      event
         */
        gotoPage: function(index, typeAnimation, callback, event) {
            typeAnimation = typeAnimation || this.options.animationType;

            var animationFunction = this['gotoPage_' + typeAnimation];

            if (!animationFunction) {
                animationFunction = this.gotoPage_none;
                core.log('animation type ' + typeAnimation + ' is not implemented in paging widget');
            }
            animationFunction.call(this, index, callback);
            this._setActivePager(index);

            this.$el.trigger($.Event('paging:pageChanged', {
                originalTarget: event ? event.currentTarget : null
            }));
        },

        gotoPage_fading: function(index, callback) {
            if (!isNaN(index)) {
                if (index === 0 || index === this.options.activePage) {
                    this.$pagingItems.removeClass('fadeIn');
                    this.$pagingItems[index].classList.remove('fadeOut');
                    this.$pagingItems[index].classList.add('fadeIn');
                } else {
                    this.$pagingItems[index].classList.add('fadeIn');
                    this.$pagingItems[this.options.activePage].classList.remove('fadeIn');
                    this.$pagingItems[this.options.activePage].classList.add('fadeOut');
                }

                this.$el.trigger('paging:endAnimation');
                callback && callback();
            }
        },

        gotoPage_monoSlider: function(index, callback) {
            if (this.options.infinity) {
                var swipe = this.pageSlider;
                var x = swipe.position.x;

                // go to the first page
                if (this.options.activePage === this.options.lengthOfPages - 1 && index === 0) {
                    swipe.translate(x + this.options.lengthOfPages * 100, 0, '%');
                }
                // go to the last page
                else if (this.options.activePage === 0 && index === this.options.lengthOfPages - 1) {
                    swipe.translate(x - this.options.lengthOfPages * 100, 0, '%');
                }

                // index + clones number
                index += 2;
            }

            this.pageSlider.animateTo(index * -100, 0, this.options.animationTime, this.options.slideAnimationFunction, function() {
                this.$el.trigger('paging:endAnimation');
                callback && callback();
            }.bind(this), '%');
        },

        gotoPage_none: function(index, callback, typeAnimation) {
            this.pageSlider.animateTo(index * -100, 0, 0, typeAnimation || mathAlgorithms.linear, function() {
                this.$el.trigger('paging:endAnimation');
                callback && callback();
            }.bind(this), '%');
        },

        _setActivePager: function(index) {
            this.options.beforePage = this.options.activePage;
            this.options.activePage = index;

            if (this.$bullets) {
                this.$bullets
                    .removeClass('active')
                    .eq(index).addClass('active');
            }

            this.$el.find('.fn-paging-item:not(.cloned)')
                .removeClass('active')
                .eq(index).addClass('active');

            if (!this.options.infinity) {
                var prevArr = this.$el.find('.fn-goto-previous');
                var nextArr = this.$el.find('.fn-goto-next');

                if (index === this.options.lengthOfPages - 1) {
                    nextArr.addClass('hidden');
                } else {
                    nextArr.removeClass('hidden');
                }

                if (index === 0) {
                    prevArr.addClass('hidden');
                } else {
                    prevArr.removeClass('hidden');
                }
            }
        },

        _handleArrowPositionUnit: function() {
            switch (this.options.arrowPositionUnit) {
                case 'percent':
                    this.options.arrowPositionUnit = '%';
                    break;
                case 'pixels':
                    this.options.arrowPositionUnit = 'px';
                    break;
                case 'em':
                    this.options.arrowPositionUnit = 'em';
                    break;
                default:
                    this.options.arrowPositionUnit = '%';
            }
        },

        /**
         * Widget destructor
         * @override
         */
        destroy: function() {
            this.pageSlider.translate(0, 0, '%');
            this.pageSlider.destroy();

            this.$el.removeClass('paging');
            this.$pages.parent().find('.fn-paging-container').remove();

            return $.Widget.prototype.destroy.call(this);
        }
    });
});
